$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let locationId = $('body').attr('event_id');
  let isDragging = false;
  let selectedColumnIndex = -1;
  let startRowIndex;
  let selectedCells = [];
  let initialSelectedCell = null;
  let prevSelectedColumnIndex = -1;
  let productIdsToUpdate = [];
  let invalidValueList = [];
  let oldValue = 0;
  let dragMultiSelectCloseAction = 'apply';
  if (p === 'organizer_event_ticket_category' && a === 'list') {
    $(document).on('mousedown', '.editable-data', function (e) {
      e.preventDefault();
      $(
        'select[name=product_group_unique_id],select[name=supplier_id_selector],select[name=mva], select[name=product_group_unique_id_drag_edit], select[name=rounding_to]'
      ).select2({
        theme: 'bootstrap4',
      });
      $('select.drag-multi-select')
        .filter(function () {
          return !$(this).data('selectpicker');
        })
        .each(function () {
          if ($(this).hasClass('select2-hidden-accessible')) {
            $(this).select2('destroy');
          }
          $(this).selectpicker();
        });
      startDrag(e);
    });

    document.addEventListener(
      'mousedown',
      function (event) {
        const target = $(event.target);
        if (target.closest('#cancelButton').length > 0) {
          dragMultiSelectCloseAction = 'cancel';
        } else if (target.closest('.editable-data').length > 0) {
          dragMultiSelectCloseAction = 'keep';
        } else {
          dragMultiSelectCloseAction = 'apply';
        }
      },
      true
    );
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          dragMultiSelectCloseAction = 'cancel';
        }
      },
      true
    );

    $(document).on('hidden.bs.select', 'select.drag-multi-select', function () {
      if (dragMultiSelectCloseAction === 'keep') {
        return;
      }
      if (dragMultiSelectCloseAction === 'cancel') {
        setDragMultiSelectValue($(this), $(this).data('initial-ids') || []);
        $('#confirmButton').prop('disabled', true);
        return;
      }
      applyDragMultiSelect($(this));
    });

    function setDragMultiSelectValue(select, ids) {
      select.val(ids);
      if (select.data('selectpicker')) {
        select.selectpicker('refresh');
      }
    }

    function clearDragMultiSelects() {
      $('select.drag-multi-select').each(function () {
        $(this).removeData('initial-ids');
        setDragMultiSelectValue($(this), []);
      });
    }

    function getDragMultiSelectChanges(select) {
      const initialIds = select.data('initial-ids') || [];
      const pickedIds = select.val() || [];
      return {
        added: pickedIds.filter((id) => !initialIds.includes(id)),
        removed: initialIds.filter((id) => !pickedIds.includes(id)),
      };
    }

    function syncDragMultiSelect(select) {
      const { added, removed } = getDragMultiSelectChanges(select);
      const sharedIds = selectedCells
        .map((cell) =>
          ($(cell).attr('data-current-ids') || '').split(',').filter(Boolean)
        )
        .reduce((shared, ids) => shared.filter((id) => ids.includes(id)));
      const pickedIds = sharedIds.filter((id) => !removed.includes(id));
      added.forEach((id) => {
        if (!pickedIds.includes(id)) {
          pickedIds.push(id);
        }
      });
      select.data('initial-ids', sharedIds);
      setDragMultiSelectValue(select, pickedIds);
      $('#confirmButton').prop(
        'disabled',
        added.length === 0 && removed.length === 0
      );
    }

    $(document).on('change', 'select.drag-multi-select', function () {
      const { added, removed } = getDragMultiSelectChanges($(this));
      $('#confirmButton').prop(
        'disabled',
        added.length === 0 && removed.length === 0
      );
    });

    function getActiveDragMultiSelect() {
      const columnType = $(selectedCells[0]).attr('data-cell-type');
      return $(
        `.drag-multi-select-wrapper[data-cell-type="${columnType}"] select.drag-multi-select`
      );
    }

    function applyDragMultiSelect(select) {
      const { added, removed } = getDragMultiSelectChanges(select);
      const columnToUpdate = $(selectedCells[0]).attr('data-cell-type');
      if (
        (added.length === 0 && removed.length === 0) ||
        select.closest('.drag-multi-select-wrapper').attr('data-cell-type') !==
          columnToUpdate
      ) {
        return;
      }

      const productIds = selectedCells.map(function (cell) {
        return $(cell).parent().attr('data-event-ticket-category-id');
      });
      resetSelection();
      updateSelectionUI();
      saveDragSelectedRelations(productIds, columnToUpdate, added, removed);
    }

    $(document).on('input', '.drag-update-input', function (e) {
      if ($(this).val()) {
        $('#confirmButton').prop('disabled', false);
      } else {
        $('#confirmButton').prop('disabled', true);
      }
    });

    //enable confirm button
    $(document).on('change', '.drag-update-input', function () {
      if (!$(this).val()) {
        return;
      }

      invalidValueList = [];

      $('#confirmButton').prop('disabled', false);

      if (
        $(this).attr('name') === 'product_group_unique_id_drag_edit' &&
        $(this).val() !== '0' &&
        selectedCells.length > 0
      ) {
        $('#confirmButton').trigger('click');
        $(this).val('0').trigger('change.select2');
      }
    });

    function startDrag(event) {
      let currentCell = $(event.target).closest('td.editable-data').get(0);
      let columnIndex = $(currentCell).index();
      let cellType = $(currentCell).attr('data-cell-type');
      if (selectedColumnIndex !== columnIndex) {
        resetSelection();
        isDragging = true;
        selectedColumnIndex = columnIndex;
        initialSelectedCell = currentCell;
      }
      startRowIndex = $(currentCell).parent().index();

      if (selectedCells.includes(currentCell)) {
        $(currentCell).removeClass('highlight');
        selectedCells.splice(selectedCells.indexOf(currentCell), 1);
      } else {
        if (cellType === 'product-sku') {
          // $(".editable-data").removeClass("highlight");
          // selectedCells = [];
          let tooltip = $(currentCell).attr('data-tooltip');

          $(currentCell).attr('data-toggle', 'tooltip');
          $(currentCell).attr('data-placement', 'left');
          $(currentCell).attr('title', tooltip);
          let tooltipInstance = new bootstrap.Tooltip(currentCell);
          $(currentCell).tooltip('show');

          setTimeout(() => {
            $(currentCell).tooltip('hide');
            tooltipInstance.dispose();
            $(currentCell).removeAttr('data-toggle');
            $(currentCell).removeAttr('data-placement');
            $(currentCell).removeAttr('title');
          }, 2000);
          return;
        }
        $(currentCell).addClass('highlight');
        selectedCells.push(currentCell);
      }

      updateSelectionUI();
      $(document).on('mousemove', drag);
      $(document).on('mouseup', endDrag);
    }

    function drag(event) {
      event.preventDefault();
      let hoveredCell = $(event.target).closest(
        '#event_ticket_category_table td.editable-data'
      );
      if (hoveredCell.length === 0 || hoveredCell.index() !== selectedColumnIndex) {
        return;
      }

      let currentRowIndex = hoveredCell.parent().index();
      hoveredCell
        .closest('tbody')
        .children('tr')
        .slice(
          Math.min(startRowIndex, currentRowIndex),
          Math.max(startRowIndex, currentRowIndex) + 1
        )
        .each(function () {
          let cell = $(this).children().get(selectedColumnIndex);
          if (
            cell &&
            $(cell).hasClass('editable-data') &&
            $(cell).attr('data-cell-type') !== 'product-sku' &&
            !selectedCells.includes(cell)
          ) {
            $(cell).addClass('highlight');
            selectedCells.push(cell);
          }
        });
    }

    function endDrag() {
      $(document).off('mousemove', drag);
      $(document).off('mouseup', endDrag);
      updateSelectionUI();
      if (
        $(selectedCells[0]).attr('data-cell-type') !== 'product-mva' &&
        getActiveDragMultiSelect().length === 0
      ) {
        $('#confirmButton').prop('disabled', true);
      }
      prevSelectedColumnIndex = selectedColumnIndex;
    }

    function resetSelection() {
      for (let cell of selectedCells) {
        $(cell).removeClass('highlight');
      }
      selectedCells = [];
      isDragging = false;
      clearDragMultiSelects();
    }

    function updateSelectionUI() {
      let newValueInput = $('#newValueInput');
      let cancelButton = $('#cancelButton');
      let confirmButton = $('#confirmButton');

      if (selectedCells.length > 0) {
        let firstSelectedCell = selectedCells[0];
        let isSelectable = $(firstSelectedCell).attr('data-selectable');
        let currentSelectedCellTpye =
          $(firstSelectedCell).attr('data-cell-type');
        if (isSelectable) {
          if (currentSelectedCellTpye == 'product-supplier') {
            $('#supplier-select').css('display', 'inline-block');
            $('#supplier-select').focus();
            $('#mva-select').css('display', 'none');
            $('#product-group-unique-select').css('display', 'none');
            $('.percent-switch-wrapper').each(function () {
              if (!$(this).hasClass('d-none')) {
                $(this).addClass('d-none');
                $(this).removeClass('d-flex');
              }
            });
          }

          if (currentSelectedCellTpye == 'product-group-unique') {
            $('#product-group-unique-select').css('display', 'inline-block');
            $('#product-group-unique-select').focus();
            $('#mva-select').css('display', 'none');
            $('#supplier-select').css('display', 'none');
            $('.percent-switch-wrapper').each(function () {
              if (!$(this).hasClass('d-none')) {
                $(this).addClass('d-none');
                $(this).removeClass('d-flex');
              }
            });
          }

          if (currentSelectedCellTpye == 'product-mva') {
            $('#confirmButton').removeAttr('disabled');
            $('#mva-select').css('display', 'inline-block');
            $('#mva-select').focus();
            $('#supplier-select').css('display', 'none');
            $('#product-group-unique-select').css('display', 'none');
            $('.percent-switch-wrapper').each(function () {
              if (!$(this).hasClass('d-none')) {
                $(this).addClass('d-none');
                $(this).removeClass('d-flex');
              }
            });
          }

          $('#textInput').css('display', 'none');
          $('#numberInput').css('display', 'none');
        } else if (currentSelectedCellTpye == 'product-name') {
          $('#supplier-select').css('display', 'none');
          $('#mva-select').css('display', 'none');
          $('#numberInput').css('display', 'none');
          $('#product-group-unique-select').css('display', 'none');
          $('#textInput').css('display', 'inline-block');
          $('#textInput').focus();

          $('.percent-switch-wrapper').each(function () {
            if (!$(this).hasClass('d-none')) {
              $(this).addClass('d-none');
              $(this).removeClass('d-flex');
            }
          });
        } else if (currentSelectedCellTpye == 'product-sku') {
          $('#supplier-select').css('display', 'none');
          $('#mva-select').css('display', 'none');
          $('#numberInput').css('display', 'none');
          $('#product-group-unique-select').css('display', 'none');
          $('#textInput').css('display', 'inline-block');
          $('#textInput').focus();

          $('.percent-switch-wrapper').each(function () {
            if (!$(this).hasClass('d-none')) {
              $(this).addClass('d-none');
              $(this).removeClass('d-flex');
            }
          });
        } else {
          $('#supplier-select').css('display', 'none');
          $('#mva-select').css('display', 'none');
          $('#textInput').css('display', 'none');
          $('#product-group-unique-select').css('display', 'none');
          $('#numberInput').css('display', 'inline-block');
          $('#numberInput').focus();

          $('.percent-switch-wrapper').each(function () {
            if ($(this).hasClass('d-none')) {
              $(this).removeClass('d-none');
              $(this).addClass('d-flex');
            }
          });
        }
        newValueInput.css('display', 'flex');
        cancelButton.css('display', 'inline-block');
        confirmButton.css('display', 'inline-block');
      } else {
        newValueInput.css('display', 'none');
        cancelButton.css('display', 'none');
        confirmButton.css('display', 'none');
      }

      const selectedCellType = $(selectedCells[0]).attr('data-cell-type');
      const relationWrapper = $(
        `.drag-multi-select-wrapper[data-cell-type="${selectedCellType}"]`
      );
      $('.drag-multi-select-wrapper').not(relationWrapper).css('display', 'none');
      if (relationWrapper.length > 0) {
        relationWrapper.css('display', 'inline-block');
        $('#supplier-select').css('display', 'none');
        $('#mva-select').css('display', 'none');
        $('#product-group-unique-select').css('display', 'none');
        $('.percent-switch-wrapper').addClass('d-none').removeClass('d-flex');
        syncDragMultiSelect(relationWrapper.find('select.drag-multi-select'));
      }
    }

    $(document).on('click', '#cancelButton', function cancelSelection(e) {
      e.preventDefault();
      $('#textInput').val('');
      $('#numberInput').val(0);
      $('#selectInput').val('male');
      $('#confirmButton').prop('disabled', true);
      invalidValueList = [];
      resetSelection();
      updateSelectionUI();
    });

    $(document).on('click', '#confirmButton', function () {
      const dragMultiSelect = getActiveDragMultiSelect();
      if (dragMultiSelect.length > 0) {
        applyDragMultiSelect(dragMultiSelect);
        return;
      }
      let newValue = null;
      let firstSelectedCell = selectedCells[0];
      let columnToUpdate = $(firstSelectedCell).attr('data-cell-type');
      let isSelectable = $(firstSelectedCell).attr('data-selectable');
      if (isSelectable) {
        if (columnToUpdate == 'product-supplier') {
          newValue = $(
            "select[name='supplier_id_selector'] option:selected"
          ).val();
        }
        if (columnToUpdate == 'product-mva') {
          newValue = $("select[name='mva'] option:selected").val();
        }
        if (columnToUpdate == 'product-group-unique') {
          newValue = $(
            "select[name='product_group_unique_id_drag_edit'] option:selected"
          ).val();
        }
      } else if (columnToUpdate == 'product-name') {
        newValue = $('#textInput').val();
      } else if (columnToUpdate == 'product-sku') {
        newValue = $('#textInput').val();
        let selectedSKUColumn = selectedCells[0];
        oldValue = $(selectedSKUColumn).attr('data-old-value');
      } else {
        let inputedValue = $('#numberInput').val().replace(',', '.');
        if (isNaN(inputedValue)) {
          return alert('Verdien må være et tall');
        } else {
          newValue = inputedValue;
        }
      }

      if (invalidValueList.length > 0) {
        let alertMessage = '';
        $.each(invalidValueList, function (index, item) {
          alertMessage +=
            item.error + ' on Product: ' + item.productName + '\n';
        });
        $('#numberInput').focus();
        return alert(alertMessage);
      }
      for (let cell of selectedCells) {
        productIdsToUpdate.push(
          $(cell).parent().attr('data-event-ticket-category-id')
        );
      }

      $('#textInput').val(''); // Clear text input field
      $('#numberInput').val(0); // Clear number input field
      $('#supplier-select').val('0'); // Reset select input field
      $('#mva-select').val('0'); // Reset select input field
      $('#confirmButton').prop('disabled', true);
      resetSelection();
      updateSelectionUI();
      updateProductDragSelected(
        productIdsToUpdate,
        columnToUpdate,
        newValue,
        locationId,
        oldValue,
        $('#percent-switch').is(':checked'),
        $('#price-rounding-select').val() || '0'
      );
      productIdsToUpdate = [];
    });
  }

  $(document).on('change', '#percent-switch', function () {
    $('#price-rounding-select').prop('disabled', !$(this).is(':checked'));
  });

  function updateProductDragSelected(
    productIds = [],
    columnToUpdate,
    newValue,
    locationId,
    oldValue = 0,
    is_percent = false,
    rounding_to = '0'
  ) {
    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_event_ticket_category/update_product_drag_selected',
      data: {
        productIds,
        columnToUpdate,
        newValue,
        locationId,
        oldValue,
        is_percent,
        rounding_to,
      },
    })
      .done(function (data) {
        if (data.error) {
          alert(data.error);
          return;
        }
        popupAlert();

        invalidValueList = [];

        getProductList();
        return true;
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });
  }

  function saveDragSelectedRelations(
    productIds,
    columnToUpdate,
    addedIds,
    removedIds
  ) {
    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_event_ticket_category/update_product_drag_selected',
      data: {
        productIds,
        columnToUpdate,
        newValue: addedIds,
        removedValue: removedIds,
        locationId,
      },
    })
      .done(function (data) {
        if (data.error) {
          alert(data.error);
          return;
        }
        popupAlert();
        getProductList();
      })
      .fail(function (response) {
        if (response.responseJSON?.redirect_url) {
          document.location.href = response.responseJSON.redirect_url;
          return;
        }
        alert(response.responseJSON?.error_message || 'Something went wrong');
      });
  }

  function getProductList() {
    let live_edit = 0;
    let search_string = $('#search_string').val();
    let product_type = $('#product_type').val();
    let supplier_id = $('#sort').data('supplier-id');
    let page = $('#event_ticket_category_table').attr('data-page');

    let formData = new FormData();
    formData.append('live_edit', live_edit);
    formData.append('search_string', search_string);
    formData.append('location_id', locationId);
    formData.append('product_type', product_type);
    formData.append('supplier_id', supplier_id);
    formData.append('page', page);
    formData.append(
      'status',
      $('#event_ticket_category_table').attr('data-status') || 1
    );
    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_event_ticket_category/search',
      data: formData,
      enctype: 'multipart/form-data',
      async: true,
      cache: false,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        if (data.html !== undefined && data.html !== null) {
          $('#product-list').empty();
          $('#product-list').append(data.html);
          window.updateMoreProductParametersVisibility?.();
        }

        $('html,body').scrollTop(0);
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });
  }
});
